<template>
    <div class="slide">

        <go-back />

        <div class="next" @click="next">
            <img src="/assets/img/icon-arrow-right-blue.svg" />
        </div>

        <div class="slide-container">

            <div class="question bigger">
                First, tell me about <span>your goals</span>.
                <div class="description">
                    To help I have listed several choices or you may enter your goals. Please select all that apply, an show me the importance of each one adding stars.
                </div>
            </div>

            <div class="answer answer-col">
                <div class="goals-ratings" v-for="goal in goals" :key="goal.id">
                    <v-checkbox
                    v-model="goal.enabled" :value="goal.enabled"
                    :label="goal.label"
                    ></v-checkbox>
                    <div class="ratings">
                        <v-rating v-model="goal.rating" small dense v-if="goal"></v-rating>
                    </div>
                </div>

                <div class="add-new">
                    <v-text-field
                        v-model="newGoalLabel"
                        placeholder="Type your customized goal"
                    >
                        <template v-slot:prepend>
                            <v-btn fab small @click="addGoal">
                                <v-icon dark>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GoBack from "./GoBack";

    export default {
        name: 'Goals',
        components: {
            GoBack
        },
        methods: {
            next() {
                this.$router.push({ name: 'IncomeNeeds' });
            },
            addGoal() {
                let newGoal = {...this.newGoal};
                newGoal.id = this.goals.length + 1;
                newGoal.label = this.newGoalLabel;
                this.goals.push(newGoal);
                this.newGoalLabel = '';
            }
        },
        data() {
            return {
                goals: [
                    {
                        id: 1,
                        enabled: false,
                        label: 'To feel comfortable that we will be able to meet or increase needs through retirement',
                        value: 'comfortable',
                        rating: 0
                    },
                    {
                        id: 2,
                        enabled: false,
                        label: 'To grow my portfolio and investments, I am a good risk taker',
                        value: 'risk',
                        rating: 0
                    },
                    {
                        id: 3,
                        enabled: false,
                        label: 'The stock market concerns me and I am looking to invest in a conservative manner',
                        value: 'conservative',
                        rating: 0
                    },
                    {
                        id: 4,
                        enabled: false,
                        label: 'To retire as soon as possible',
                        value: 'retire',
                        rating: 0
                    },
                    {
                        id: 5,
                        enabled: false,
                        label: 'To make sure we leave money to our children. Our goal is to maximize our estate',
                        value: 'estate',
                        rating: 0
                    },
                    {
                        id: 6,
                        enabled: false,
                        label: 'Help me reduce my taxes',
                        value: 'taxes',
                        rating: 0
                    },
                    {
                        id: 7,
                        enabled: false,
                        label: 'Make sure that when I pass my spouse will be financially secure',
                        value: 'spouse',
                        rating: 0
                    },
                ],
                newGoal: {
                    id: 0,
                    enabled: false,
                    label: '',
                    value: 'custom',
                    rating: 0
                },
                newGoalLabel: '',
            }
        }
    }
</script>